module.exports = __webpack_public_path__ + "fromGroomToParents-jp-n.0d2869b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToParents-jp-n.jpg
// module id = ov5z
// module chunks = 0